
<div class="modal-dialog confirm-dialog" style="max-width: 38%;">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">{{title}}</h5>
      <button class="close" type="button" (click)="cancel()">&times;</button>
    </div>
    <div class="modal-body">
      <div [ngStyle]="{'color': title === 'Warning' ? '#eb9b03' : 'inherit' ,'white-space': 'pre-wrap'}" [innerHTML]="message"></div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-secondary" type="button" (click)="cancel()">{{cancelText}}</button>
      <button class="btn btn-primary" type="button" (click)="ok()">{{ confirmText}}</button>
    </div>
  </div>
</div>